module.exports = __webpack_public_path__ + "static/img/rubber_256.092891e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rubber_256.png
// module id = H5xI
// module chunks = 0